import React, { useRef, useEffect } from "react"

interface Props {
    config?: Chart.ChartConfiguration
    hasLabels?: boolean
}

export const Chart: React.FC<Props> = ({
    config,
    hasLabels = false
}: Props) => {
    const ref = useRef<HTMLCanvasElement>(null)
    const chartRef = useRef<Chart>()

    useEffect(() => {
        if (!ref.current) return

        const context = ref.current.getContext("2d")

        if (!context) return
        ;(async () => {
            const [Chart, ChartDataLabels] = await Promise.all([
                import("chart.js").then(chart => chart.default),
                import("chartjs-plugin-datalabels").then(
                    plugin => plugin.default
                )
            ])

            if (chartRef.current !== undefined) {
                chartRef.current.destroy()
            }

            chartRef.current = new Chart(context, {
                ...(hasLabels && { plugins: [ChartDataLabels] }),
                ...config
            })
        })()
    }, [config, hasLabels])

    useEffect(() => {
        return () => {
            chartRef.current?.destroy()
        }
    }, [])

    return <canvas ref={ref} />
}
